/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_SubtitleInputs */

const tr_mesafeli_subtitle = /** @type {(inputs: Mesafeli_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel™ SaaS aboneliğine ilişkin Sağlayıcı (Emonse® E-Ticaret Ltd. Şti.) ile Abone arasında akdedilen mesafeli hizmet sözleşmesi. 6502 sayılı Kanun ve Mesafeli Sözleşmeler Yönetmeliği uyarınca hazırlanmıştır.`)
};

const en_mesafeli_subtitle = /** @type {(inputs: Mesafeli_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance service agreement concluded between the Provider (Emonse® E-Ticaret Ltd. Şti.) and the Subscriber in respect of the ShopPanel™ SaaS subscription. Prepared in accordance with Law No. 6502 and the Mesafeli Sözleşmeler Yönetmeliği (Distance Contracts Regulation).`)
};

const de_mesafeli_subtitle = /** @type {(inputs: Mesafeli_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fernabsatz-Dienstleistungsvertrag über das ShopPanel™ SaaS-Abonnement, geschlossen zwischen dem Anbieter (Emonse® E-Ticaret Ltd. Şti.) und dem Abonnenten. Erstellt gemäß dem Gesetz Nr. 6502 und der Mesafeli Sözleşmeler Yönetmeliği (Verordnung über Fernabsatzverträge).`)
};

const ru_mesafeli_subtitle = /** @type {(inputs: Mesafeli_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Договор дистанционного оказания услуг, заключаемый между Поставщиком (Emonse® E-Ticaret Ltd. Şti.) и Абонентом в отношении подписки ShopPanel™ SaaS. Подготовлен в соответствии с Законом № 6502 и Mesafeli Sözleşmeler Yönetmeliği (Положение о дистанционных договорах).`)
};

/**
* | output |
* | --- |
* | "Distance service agreement concluded between the Provider (Emonse® E-Ticaret Ltd. Şti.) and the Subscriber in respect of the ShopPanel™ SaaS subscription. Pr..." |
*
* @param {Mesafeli_SubtitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_subtitle = /** @type {((inputs?: Mesafeli_SubtitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_SubtitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_subtitle(inputs)
	if (locale === "de") return de_mesafeli_subtitle(inputs)
	if (locale === "ru") return ru_mesafeli_subtitle(inputs)
	return tr_mesafeli_subtitle(inputs)
});